import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function Hero() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToPackages = () => {
    const packagesSection = document.getElementById('packages-section');
    if (packagesSection) {
      packagesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen overflow-hidden">
      {/* Iframe Background */}
      <div className="absolute inset-0 w-full h-full" style={{ zIndex: 0 }}>
        <iframe
          src="https://streamable.com/e/z51ldr?autoplay=1&muted=1&loop=1&controls=0"
          allow="autoplay; fullscreen"
          allowFullScreen
          frameBorder="0"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '177.78vh',
            height: '56.25vw',
            minWidth: '100%',
            minHeight: '100%',
            transform: 'translate(-50%, -50%)',
            border: 'none',
            pointerEvents: 'none',
          }}
          title="Hero background video"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50" style={{ zIndex: 1 }}></div>

      {/* Gradient fade */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/70" style={{ zIndex: 2 }}></div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-black/50' : 'bg-transparent'}`}>
        <div className="max-w-[1400px] mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/694cee17-fcfc-433e-9858-ffd49fe7e172.png"
              alt="Daily Nest Publishing"
              className="h-12 w-auto"
            />
            <span className="text-white text-xl font-semibold">Daily Nest Publishing</span>
          </div>
          <div className="flex items-center gap-8">
            <a href="#services" className="text-gray-300 hover:text-[#D4AF37] transition-colors text-sm font-medium cursor-pointer">Services</a>
            <a href="#packages" className="text-gray-300 hover:text-[#D4AF37] transition-colors text-sm font-medium cursor-pointer">Packages</a>
            <a href="#process" className="text-gray-300 hover:text-[#D4AF37] transition-colors text-sm font-medium cursor-pointer">Process</a>
            <button
              onClick={scrollToContact}
              className="bg-[#D4AF37] text-black px-6 py-2.5 rounded-full text-sm font-medium hover:brightness-110 transition-all whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Content — centered over iframe */}
      <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-8 pt-24 pb-20" style={{ zIndex: 10 }}>
        <div className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-medium mb-8">
          Premium Authority Publishing Studio
        </div>

        <h1 className="text-white text-7xl font-bold leading-[1.1] mb-8 max-w-4xl">
          Publish Your Book.<br />
          Build Your Brand.
        </h1>

        <p className="text-[#D9D9D9] text-xl leading-relaxed max-w-[600px] mb-12">
          We help authors, experts, and entrepreneurs turn manuscripts into professionally published books, authority assets, and market-ready brands.
        </p>

        <div className="flex items-center gap-4 flex-wrap justify-center">
          <button
            onClick={scrollToContact}
            className="bg-[#D4AF37] text-black px-8 h-14 rounded-full font-medium hover:brightness-110 transition-all shadow-lg shadow-[#D4AF37]/30 whitespace-nowrap cursor-pointer"
          >
            Book a Free Strategy Call
          </button>
          <button
            onClick={scrollToPackages}
            className="bg-transparent border-2 border-[#D4AF37] text-[#D4AF37] px-8 h-14 rounded-full font-medium hover:bg-[#D4AF37]/10 transition-all whitespace-nowrap cursor-pointer"
          >
            View Publishing Packages
          </button>
          <button
            onClick={() => navigate('/author-funding')}
            className="bg-white/10 border border-white/30 text-white/90 px-8 h-14 rounded-full font-medium hover:bg-white/20 hover:border-white/50 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            Explore Author Funding
          </button>
        </div>
      </div>

      {/* Bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/20 to-transparent" style={{ zIndex: 10 }}></div>
    </section>
  );
}
